// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fj-0";